import Vue from "vue";
import Vuex from "vuex";

import { administrator } from "./administrator.module";
import { family } from "./family.module";
import { firmware } from "./firmware.module";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    administrator,
    family,
    firmware
  }
});
